import { CustomErrorInterface } from "../entities/Common";

export const createCustomError = ({
  reasonCode,
  title,
  description,
}: CustomErrorInterface): CustomErrorInterface => {
  return {
    reasonCode,
    title,
    description,
  };
};
